import { NativeError, RuntimeError } from '@belimo-retrofit-portal/logic';
import { SagaIterator } from 'redux-saga';
import { sentryCatch } from 'src/modules/config/utils/sentryCatch';
import { FEEDBACK_TRIGGER } from 'src/modules/feedback/actions/FeedbackActions';
import { resetFeedbackRequestTrigger } from 'src/modules/feedback/sagas/utils/resetFeedbackRequestTrigger';
import { sendFeedbackRequestTrigger } from 'src/modules/feedback/sagas/utils/sendFeedbackRequestTrigger';
import { logDebug, logError } from 'src/sagas/utils/logging';
import { call, put } from 'typed-redux-saga';

export function* feedbackTriggerRequestSaga(): SagaIterator<void> {
  try {
    yield* call(logDebug, 'Triggering feedback request...');
    yield* put(FEEDBACK_TRIGGER.pending());

    const result = yield* call(sendFeedbackRequestTrigger);
    if (result.triggered) {
      yield* call(resetFeedbackRequestTrigger);
    }

    yield* put(FEEDBACK_TRIGGER.success(result));
    yield* call(logDebug, 'Triggering feedback request... done', result);
  } catch (error) {
    const wrapped = new RuntimeError('Could not trigger feedback request', {}, NativeError.wrap(error));

    yield* put(FEEDBACK_TRIGGER.failure(wrapped));
    yield* call(logError, 'Triggering feedback request... error', error);

    yield* call(sentryCatch, wrapped);
  }
}
